<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        :needPage="false"
        tableId="DcCosAppidManage"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'status'">
            <a-tag color="red" v-if="record.status === 1">停用</a-tag>
            <a-tag color="green" v-else>启用</a-tag>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'sys_appidmange_edit_btn'">编辑</a-button>
              <a-button
                type="link"
                @click="openAndStopRow(record, 1)"
                v-if="vIfAndPermission('sys_appidmange_closeopen_btn', !record.status)"
                >禁用</a-button
              >
              <a-button
                type="link"
                @click="openAndStopRow(record, 0)"
                v-if="vIfAndPermission('sys_appidmange_closeopen_btn', record.status)"
                >启用</a-button
              >
              <a-button type="link" @click="ResetRow(record)" v-permission="'sys_appidmange_reset_btn'"
                >重置APPSECRET</a-button
              >
              <a-button type="link" @click="deleteRow(record)" v-permission="'sys_appidmange_delete_btn'"
                >删除</a-button
              >
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'sys_appidmange_add_btn'">新增</a-button>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { getAppidList, deleteAppid, resetAppid, updateAppid } from '@/api/marketing/marketingManage'
import vIfAndPermission from '@/utils/ifAndPermission'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { AppidSubmitParams } from '@/typings/api/marketingManage'
export default { name: 'DcCosZbuAppidMange' }
</script>
<script setup lang="ts">
const editModalRef = ref<{ toggle:(row?: AppidSubmitParams) => void }>()

const tableRef = ref()
const queryForm = reactive({
  arkCode: '',
  customerName: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await getAppidList()
  callBack(res)
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  { title: 'APPID', dataIndex: 'appKey', width: 330 },
  { title: 'APPSECRET', dataIndex: 'appSecret', width: 330 },
  { title: '名称', dataIndex: 'appName' },
  { title: '是否启用', dataIndex: 'status' },
  {
    title: '目标系统',
    dataIndex: 'subdomain',
    dicData: [
      { label: '谷仓', value: 'cos_fbu' },
      { label: '云途', value: 'cos_lbu' }
    ]
  },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '操作时间', dataIndex: 'createTime', width: 200 },

  {
    title: '操作',
    dataIndex: 'action',
    width: 200,
    fixed: 'right'
  }
])
const addEdit = (_row?: AppidSubmitParams) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: AppidSubmitParams) => {
  Modal.delete({
    name: row.appName,
    onOk() {
      deleteAppid({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
        success()
      })
    }
  })
}
const ResetRow = (row: AppidSubmitParams) => {
  DcConfirm.warning({
    title: '重置提示！',
    content: '是否重置：' + row.appName,
    cancelText: '取消',
    okText: '继续',
    onOk() {
      resetAppid({ id: row.id }).then(() => {
        DcMessage.success('重置成功')
        success()
      })
    }
  })
}
const openAndStopRow = (row: AppidSubmitParams, type: number) => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      updateAppid({ id: row.id, status: type }).then(() => {
        DcMessage.success('操作成功')
        success()
      })
    }
  })
}
</script>

<style scoped></style>
